module.exports = __webpack_public_path__ + "images/application/i-info-circle-8536afcf.svg";